export const ADPOPCORN_PLACEMENT_IDS = {
  //* 홈 화면 상단 퀵메뉴 "혜택"
  HOME_QUICK_MENU: {
    android: '9OT0HR3hgIze',
    ios: 'q2ysL5KbViPJ',
  },
  //* 하단 네비게이션 "혜택" — 일반 화면
  BOTTOM_NAV: {
    android: 'HNgUu6TyfYX4',
    ios: 'taXej7CSQ9LT',
  },
  //* 하단 네비게이션 "혜택" — 웰마켓 화면
  BOTTOM_NAV_WELMARKET: {
    android: 'Xoxr71EFut6M',
    ios: 'IeqtJjb1t462',
  },
  //* 우측 상단 메뉴 팝오버 + 마이페이지 메뉴 "혜택"
  MY_ENTRY: {
    android: 'cNmOt5cfk5Hl',
    ios: 'YlemNwjsRiGS',
  },
} as const;

export type AdpopcornPlacementKey = keyof typeof ADPOPCORN_PLACEMENT_IDS;

//* [임시] 내부 테스트용 노출 허용 memberOAuthId 화이트리스트.
//* 이 목록에 포함된 멤버에게만 혜택(에어드랍) 진입점이 노출된다.
//* 정식 오픈 시 이 상수와 useAdpopcornPlacement의 가드를 함께 제거한다.
export const ADPOPCORN_INTERNAL_TEST_MEMBER_OAUTH_IDS: number[] = [
  391973, //* 케빈
  40396, //* 안나
  746805, //* 제이
  256477, //* 애런
  506593, //* 크리스
  390951, //* 나
];
